import { ComponentsModule } from './../../../components/components.module';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from './../../../material.module';

import { IonicModule } from '@ionic/angular';

import { UserDetailPage } from './user-detail.page';

const routes: Routes = [
  {
    path: '',
    component: UserDetailPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    MaterialModule,
    RouterModule.forChild(routes)
    ],
  declarations: [UserDetailPage]
})
export class UserDetailPageModule {}
